import { render } from "./EmpHcards.vue?vue&type=template&id=1c109d1b&scoped=true"
import script from "./EmpHcards.vue?vue&type=script&lang=js"
export * from "./EmpHcards.vue?vue&type=script&lang=js"

import "./EmpHcards.vue?vue&type=style&index=0&id=1c109d1b&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c109d1b"]])

export default __exports__